<template>
  <div class="payment posR">
    <header-purchase v-if="purchase.id"
                     :title="event.title"
                     :start-date="event.start_date"
                     :end-date="event.end_date"
                     :type="event.type"
                     :venue="event.venue" />
    <steps :active="2" />
    <payment v-if="purchase.id && (paymentMethods.three_ds || paymentMethods.stripe || paymentMethods.telecoming)" />
    <banner-download-app />
    <fb-pixel v-if="purchase.id && event.facebook_pixel_js"
              :fb-pixel="event.facebook_pixel_js" />
    <ga-pixel v-if="purchase.id && event.google_pixel_js"
              :ga-pixel="event.google_pixel_js" />
    <loader v-show="loading"
            class="load-more-loader"
            :middle="true" />
  </div>
</template>

<script>
import HeaderPurchase from '@/components/header-purchase/HeaderPurchase.vue'
import BannerDownloadApp from '@/components/banner-download-app/BannerDownloadApp.vue'
import Payment from '@/components/payment/Payment.vue'
import FbPixel from '@/components/pixels/FbPixel.vue'
import GaPixel from '@/components/pixels/GaPixel.vue'
import Loader from '@/components/loader/Loader.vue'
import Steps from '@/components/steps/Steps.vue'

export default {
  layout: 'basic',
  components: {
    HeaderPurchase,
    BannerDownloadApp,
    Payment,
    FbPixel,
    GaPixel,
    Loader,
    Steps
  },
  data: () => ({
    loading: true
  }),
  computed: {
    event() {
      return this.$store.state.event.detail
    },
    paymentMethods() {
      return this.$store.state.payment.methods
    },
    purchase() {
      return this.$store.state.purchase.detail
    }
  },
  async created() {
    let queryPurchase = {
      reference: this.$route.params.reference
    }
    await this.$store.dispatch('purchase/detail', queryPurchase).catch(res => {
      this.$router.push({
        path: `/compra-expirada/`
      })
    })
    if (
      this.$store.state.purchase.detail &&
      this.$store.state.purchase.detail.id
    ) {
      let queryMethods = {
        id: this.$store.state.purchase.detail.event.id
      }
      await this.$store.dispatch('payment/getMethods', queryMethods)
      let queryEvent = {
        slug: this.$store.state.purchase.detail.event.slug
      }
      await this.$store.dispatch('event/detail', queryEvent)
      if (
        !this.$store.state.payment.methods.stripe &&
        !this.$store.state.payment.methods.stripe_fallback &&
        this.$store.state.payment.methods.reuse &&
        this.$store.state.auth.userIsAuthenticated &&
        !this.$store.state.purchase.detail.buyer
      )
        await this.$store.dispatch('user/cards')
    }
  },
  async mounted() {
    this.$ga.page({
      page: window.location.pathname,
      title: 'Payment',
      location: window.location.href
    })
    this.loading = false
  }
}
</script>
